var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-row"},[_c('span',{staticClass:"name",on:{"click":_vm.handleLink}},[_vm._v(_vm._s(_vm.department.name))]),_c('span',{staticClass:"district"},[_vm._v(_vm._s(_vm.department.district))])])
}
var staticRenderFns = []

export { render, staticRenderFns }